<template>
  <div class="c-page">
    <div v-if="app.appError"></div>
    <transition name="page" mode="out-in">
      <router-view></router-view>
    </transition>
    <!-- <Spinner /> -->
  </div>
</template>

<script>
import Vue from "vue";
import settings from "./settings/settings";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("app");
import { staticData } from "@/helper/staticData.js";
import { matchesPattern } from "@/helper/matchesPatternUrl.js";
// import Spinner from '@/components/spinner/spinner.vue';

export default Vue.extend({
  name: "App",
  components: {
    // Spinner
  },
  computed: {
    ...mapGetters(["app"]),
  },
  beforeMount() {
    this.setHost(this);
    this.setContainerId(this);
    this.setDisableAppFromSettings(this);
    if (settings.parameters.referrer) {
      const matche_am = matchesPattern(settings.parameters.referrer, [
        "*.am.dk",
        "localhost",
      ]);
      if (matche_am) {
        this.$store.dispatch("app/isAm", matche_am);
      }
    }
  },
  mounted() {
    // guard 🛡⚔
    if (this.$router.currentRoute.name != "Step1" && this.app.price == -1)
      this.$router.push({ name: "Step1" });

    this.lockdownCarPrice(this);
  },
  watch: {
    ["app.ins"]: {
      deep: true,
      handler() {
        if (!this.app.disableApp) {
          this.$store.dispatch("app/getInsurancePrice");
        }
      },
    },
  },
  methods: {
    setHost: (that) => {
      if (settings.host && settings.host != "") {
        that.$store.dispatch("app/setHost", settings.host);
      }
    },
    setContainerId: (that) => {
      if (settings.containerId && settings.containerId != "") {
        that.$store.dispatch("app/setContainerId", settings.containerId);
      }
    },
    setDisableAppFromSettings: (that) => {
      let disableapp = false;
      if (settings.parameters.disableapp) {
        let parameterDisableapp = settings.parameters.disableapp;
        if (typeof parameterDisableapp === "boolean") {
          if (parameterDisableapp) {
            disableapp = true;
          }
        } else if (parameterDisableapp === "true") {
          disableapp = true;
        }

        if (disableapp) {
          that.$store.dispatch("app/disableAppFromSettings", true);
        }
      }
    },
    lockdownCarPrice: (that) => {
      const lockdownCarPrice = Number(settings.parameters.lockdownprice);
      /** @type {string} */
      const vehicletype = settings.parameters.vehicletype;
      if (
        lockdownCarPrice != null &&
        lockdownCarPrice != undefined &&
        lockdownCarPrice != -1
      ) {
        /**
         * @description Hello **world**!
         * @typedef {{
         *  value: string
         *  title: string
         * }}
         * Props
         *
         * @type Array<Props>
         */
        const selectDataVehicleValueNew = staticData.step1.selectDataVehicleValueNew;
        let item = selectDataVehicleValueNew.find((x) => {
          if (vehicletype && vehicletype == "van") {
            if (x.value.startsWith("van")) {
              if (lockdownCarPrice <= x.value.replace("van-", "")) return x;
            }
          } else {
            const value = Number(x.value);
            if (!isNaN(value)) if (lockdownCarPrice <= value) return x;
          }
        });

        if (item && item != undefined && item != null) {
          // that.$store.dispatch('app/vehicleAndCarTypeValue', item);
          that.$store.dispatch("app/conditionslockdownCarPrice", {
            activated: true,
            value: parseInt(lockdownCarPrice),
            cartype: item,
          });
        }
      }
    },
  },
});
</script>

<style lang="scss">
@import "@/assets/scss/essentials/essentials.scss";
@import "@/assets/scss/essentials/_flex-grid.scss";
@import "@/assets/scss/essentials/_space.scss";
@import "@/assets/scss/components/body.scss";
@import "@/assets/scss/components/page.scss";

@media only screen and (max-width: 811px) {
  .hide-mobile {
    display: none !important;
  }
}

.d-flex {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  &.row {
    flex-direction: row;
  }
  .flex-50 {
    flex-basis: 50%;
    width: 50%;
    max-width: 50%;
    flex-basis: 50%;
  }
}

.page-enter,
.page-leave-to {
  opacity: 0;
  //transform: translateX(-120px);
}
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
